import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Sparkle } from "@phosphor-icons/react";
import Shelf from "Pages/Categories/Shelves/Shelf";
import { LoginAuthContext } from "Context/Authentication/LoginAuth";
import BASE_URL from "Utilities/BASE_URL";
import MyCoursesEmptyHero from "./MyCoursesEmptyHero";

const EmptyState = ({ recommended: providedRecommended, withHero = false }) => {
  const { t, i18n } = useTranslation();
  const { token } = useContext(LoginAuthContext);
  const needsFetch = providedRecommended === undefined;

  const { data } = useQuery({
    queryKey: ["my-courses-recommended", i18n.language],
    queryFn: async () => {
      const res = await fetch(
        `${BASE_URL}/${i18n.language}/home/browse-bundle`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        }
      );
      if (!res.ok) throw new Error("Bundle fetch failed");
      const json = await res.json();
      return json?.data || null;
    },
    enabled: needsFetch,
    staleTime: 5 * 60 * 1000,
  });

  const recommended = needsFetch
    ? data?.newThisWeek || []
    : providedRecommended || [];

  return (
    <div className="mt-8">
      {withHero && <MyCoursesEmptyHero />}

      <Shelf
        title={t("my_courses.recommended_for_you")}
        icon={<Sparkle size={20} className="text-primary" weight="fill" />}
        items={recommended}
      />
    </div>
  );
};

export default EmptyState;
